import { createRouter, createWebHistory } from 'vue-router'

import { useI18nLoader } from '@/i18n'

import admin from './admin'
import auth from './auth'
import site from './site'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/admin',
    },
    ...site,
    ...auth,
    ...admin,
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('@/views/site/NotFoundPage.vue'),
    },
  ],

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
})

// add title to page when navigating
router.beforeEach((to: any) => {
  // You can specify the type for `to` more precisely if needed
  const { title, description } = to.meta as { title: string; description: string }
  const defaultTitle = 'InvestiBene'
  const defaultDescription = 'InvestiBene'

  // Concatenate the page title to the default title
  document.title = title ? `${defaultTitle} - ${title}` : defaultTitle

  const descriptionElement = document.querySelector(
    'head meta[name="description"]',
  ) as HTMLMetaElement | null

  if (descriptionElement) {
    descriptionElement.setAttribute('content', description || defaultDescription)
  }
})

useI18nLoader(router)
export default router
